module.exports = __webpack_public_path__ + "static/media/s_nor_01.67d75f3d.png";